import { UnitCode } from '~/graphql/graphql';
import type { Parsed } from '~/utils/parsed';

// Bounds of the capacity column, numeric(12,3).
export const CAPACITY_SCALE = 3;
export const MIN_CAPACITY = 0.001;
export const MAX_CAPACITY = 999_999_999.999;

const WHOLE_NUMBER = /^\d+$/;
const DECIMAL_NUMBER = new RegExp(`^\\d+(\\.\\d{1,${CAPACITY_SCALE}})?$`);

export const capacityMessageParams = {
  min: MIN_CAPACITY.toLocaleString('en-US', {
    maximumFractionDigits: CAPACITY_SCALE,
  }),
  max: MAX_CAPACITY.toLocaleString('en-US', {
    maximumFractionDigits: CAPACITY_SCALE,
  }),
};

export const wholeCapacityMessageParams = {
  min: '1',
  max: Math.floor(MAX_CAPACITY).toLocaleString('en-US'),
};

export function parseCapacityInput(
  raw: string,
  unit: UnitCode
): Parsed<number> {
  const text = raw.trim();
  const pattern = unit === UnitCode.Pcs ? WHOLE_NUMBER : DECIMAL_NUMBER;
  if (!pattern.test(text)) {
    return { valid: false };
  }
  const value = Number(text);
  return value >= MIN_CAPACITY && value <= MAX_CAPACITY
    ? { valid: true, value }
    : { valid: false };
}
